import { render, staticRenderFns } from "./DialogSos.vue?vue&type=template&id=5bcb07fb"
import script from "./DialogSos.vue?vue&type=script&lang=js"
export * from "./DialogSos.vue?vue&type=script&lang=js"
import style0 from "./DialogSos.vue?vue&type=style&index=0&id=5bcb07fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports